<template>
  <div class="overlay">
    <div class="page-lock">
      <div class="page-logo">
        <router-link to="/login" class="brand" >
          <img src="/static/pages/img/logo.png" alt="logo">
        </router-link>
      </div>
      <div class="alert alert-danger" v-if="false">
        <button class="close" data-close="alert"></button>
        <span>{{ validMessage }} </span>
      </div>
      <div class="page-body">
        <div class="lock-head">Password Expired</div>
        <div class="lock-body">
          <div class="lock-cont">
            <div class="lock-item lock-item-full">
              <p class="pass-info">Please enter your current and new password to continue.</p>
              <form class="lock-form pull-left" data-vv-scope="remind-form" v-on:submit.prevent="onSubmit">
                <div class="form-group" :class="{ 'has-error': errors.has('remind-form.Old Password') }">
                  <input class="form-control placeholder-no-fix" type="password" autocomplete="off" placeholder="Old Password"
                         name="Old Password" v-model="oldPass" v-validate="'required'">
                  <span v-show="errors.has('remind-form.Old Password')" class="help-block">{{ errors.first('remind-form.Old Password') }}</span>
                </div>
                <div class="form-group" :class="{ 'has-error': errors.has('remind-form.New Password') }">
                  <input class="form-control placeholder-no-fix" type="password" autocomplete="off" placeholder="New Password"
                         name="New Password" v-model="password" v-validate="{required:true, min:6, max:16, password: true}">
                  <span v-show="errors.has('remind-form.New Password')" class="help-block">{{ errors.first('remind-form.New Password') }}</span>
                </div>
                <div class="form-group" :class="{ 'has-error': errors.has('remind-form.Confirm New Password') }">
                <input class="form-control placeholder-no-fix" type="password" autocomplete="off" placeholder="Confirm New Password"
                       name="Confirm New Password" v-model="password2" v-validate="{required: true, is: password}">
                  <span v-show="errors.has('remind-form.Confirm New Password')" class="help-block">{{ errors.first('remind-form.Confirm New Password') }}</span>
                </div>
                <div class="form-actions">
                  <button type="submit" class="btn btn-warning mt-ladda-btn ladda-button check-token"
                          data-style="expand-left">
                    <span class="ladda-label">Submit</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="lock-bottom">
          <router-link to="/login" v-if="false">Already changed?</router-link>
        </div>
      </div>
      <div class="page-footer-custom">&copy; {{ new Date().getFullYear() }} CaseMGR Solutions, Inc. All Rights Reserved.</div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  export default {
    data() {
      return {
        token: this.$route.params.token,
        oldPass: '',
        password: '',
        password2: ''
      }
    },
    inject: {
      $validator: '$validator'
    },
    mounted() {
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({
        changePassword: 'CHANGE_PASSWORD_ACTION'
      }),
      onSubmit() {
        const context = Ladda.create(document.querySelector('.check-token'));
        this.$validator.validateAll('remind-form').then((result) => {
          if (result) {
            this.changePassword({token: this.$route.params.token, oldPass: this.oldPass, password: this.password, context})
          }
        });
      }
    },
  }
</script>
<style scoped>
  .overlay {
    background-color: #ffffff;
    min-height: 100vh;
    min-width: 100vw;
    position: absolute;
  }

  .brand img {
    width: 100%;
  }

  .page-lock .lock-cont {
    width: 100%;
  }

  .lock-form .form-group .form-control {
    width: 100%;
  }

  .lock-form .form-actions .btn {
    width: 100%;
  }
  .pass-info {
    margin-top: 0px;
  }
  .lock-form {
    padding-left: 0px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// NewPass.vue?0a5f4eca